module.exports = __webpack_public_path__ + "static/media/Image-Future.52a68660.png";